import { render, staticRenderFns } from "./skeleton-grid.vue?vue&type=template&id=48a8cf6e&scoped=true"
import script from "./skeleton-grid.vue?vue&type=script&lang=js"
export * from "./skeleton-grid.vue?vue&type=script&lang=js"
import style0 from "./skeleton-grid.vue?vue&type=style&index=0&id=48a8cf6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a8cf6e",
  null
  
)

export default component.exports